import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import webinarCarousalImg from "../../../assets/Images/Carousel-1.webp";
import webinarCarousalImg1 from "../../../assets/Images/Azad-min.webp";
import webinarCarousalImg2 from "../../../assets/Images/Sanskirt-min.webp";
import webinarCarousalImg3 from "../../../assets/Images/Shine-min.webp";
import CSM from "../../../assets/Images/CSM.webp";
import Appmin from "../../../assets/Images/APP-min.webp";

const WebimarCarousel = ({isDesktopView}) => {
  console.log(isDesktopView,"lpad");
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow:isDesktopView? 2:1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    pauseOnHover: false,
    dotsClass: "slick-dots orDots",
  };

  return (
    <Slider {...settings}>
      <div className="webinarCarousal">
        <div className="webinarCarousal_content">
          <p className="webinarCarousal_content_text">
            <span className="webinarCarousal_content_textHeading">About Dr. Vivek Bindra
</span><br/><br/>
He is the CEO & Founder of Bada Business. He is a Leadership Consultant and an Inspirational Business Coach. He has more than 3.2 Crores followers across Social Media and his videos have received viewership of more than 576 Crores.
          </p>
        </div>
      </div>
      <div className="webinarCarousal">
        {/* <img style={{borderRadius: "8px 8px 0px 0px"}} src={webinarCarousalImg1} alt="" className="webinarCarousal_img" /> */}
        <div className="webinarCarousal_content">
          {/* <h3 className="webinarCarousal_content_heading">Video Portal</h3> */}
          <p className="webinarCarousal_content_text2">
            <span className="webinarCarousal_content_textHeading2">About Free Webinar</span><br/><br/>
            Classplus joins hands with Dr. Vivek Bindra to bring you a Mega Event to help educators from all over India to grow & reach millions of students. Join us to know how you can become a successful 'Teacherpreneur' and a National Brand!
          </p>
          
        </div>
      </div>
      {/* <div className="webinarCarousal">

        <div className="webinarCarousal_content">
          <p className="webinarCarousal_content_text">
          Ravi Prakash Azad Sir established Azad IAS to remove the shortcomings when it comes to teaching for the Civil Service Examinations. Using his own branded mobile app, he ensures to provide quality classroom programs, tests, and study materials.
          </p>
        </div>
      </div>
      <div className="webinarCarousal">

        <div className="webinarCarousal_content">
          <p className="webinarCarousal_content_text">
          Ravi Prakash Azad Sir established Azad IAS to remove the shortcomings when it comes to teaching for the Civil Service Examinations. Using his own branded mobile app, he ensures to provide quality classroom programs, tests, and study materials.
          </p>
        </div>
      </div> */}
      {/* <div className="webinarCarousal">
        <img src={CSM} alt="" className="webinarCarousal_img" />
        <div className="webinarCarousal_content">
          <h3 className="webinarCarousal_content_heading">Online Test Portal</h3>
          <p className="webinarCarousal_content_text">
            Conducting online tests without the hassle of checking is now
            possible! Give your students enough practice by using our online
            test portal. Automatically upload all your question papers.
          </p>
          <button className="webinarCarousal_content_btn">
            <Link to="/features">Know more</Link>
          </button>
        </div>
      </div> */}

      {/* <div className="webinarCarousal">
        <img src={Appmin} alt="" className="webinarCarousal_img" />
        <div className="webinarCarousal_content">
          <h3 className="webinarCarousal_content_heading">
            Your Coaching’s Mobile App
          </h3>
          <p className="webinarCarousal_content_text">
            One single mobile app by your coaching institute's name that can
            help you in becoming a digital brand. Digitise all your academic
            activities through the platform and give your students and their
            parents with the experience they desire for!
          </p>
          <button className="webinarCarousal_content_btn">
            <Link to="/features">Know more</Link>
          </button>
        </div>
      </div> */}
    </Slider>
  );
};

export default WebimarCarousel;
